"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("react-date-range/dist/styles.css");
require("react-date-range/dist/theme/default.css");
var _enUS = _interopRequireDefault(require("date-fns/locale/en-US"));
var _es = _interopRequireDefault(require("date-fns/locale/es"));
var _reactDateRange = require("react-date-range");
var _MaterialIcon = _interopRequireDefault(require("../MaterialIcon"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _dayjs = _interopRequireDefault(require("dayjs"));
var _styledComponents = require("styled-components");
var _reactI18next = require("react-i18next");
var _styled = require("./styled");
var _react = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const TODAY = (0, _dayjs.default)().format('YYYY-MM-DD');
const LOCALES = {
  en: _enUS.default,
  es: _es.default
};
const DateRangePicker = _ref => {
  let {
    allowFutureDays = true,
    calendarHeight = 200,
    disabled = false,
    endValue = TODAY,
    height = '40px',
    margin = '5px 0px',
    onChange = () => null,
    position = 'left',
    startValue = TODAY
  } = _ref;
  const {
    primaryColor
  } = (0, _styledComponents.useTheme)();
  const rangeRef = (0, _react.useRef)();
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const [endDate, setEndDate] = (0, _react.useState)(TODAY);
  const [isOpen, setIsOpen] = (0, _react.useState)(false);
  const [startDate, setStartDate] = (0, _react.useState)(TODAY);
  (0, _react.useEffect)(() => {
    if (endValue) {
      setEndDate((0, _dayjs.default)(endValue).format('YYYY-MM-DD'));
    }
  }, [endValue, setEndDate]);
  (0, _react.useEffect)(() => {
    if (startValue) {
      setStartDate((0, _dayjs.default)(startValue).format('YYYY-MM-DD'));
    }
  }, [startValue, setStartDate]);
  (0, _react.useEffect)(() => {
    if (endDate !== startDate) {
      setTimeout(() => setIsOpen(false), 300);
    }
    //eslint-disable-next-line
  }, [endDate]);
  const toggleOpen = () => setIsOpen(isOpen => !isOpen);
  const handleChange = value => {
    const {
      selection: {
        endDate,
        startDate
      }
    } = value;
    const endString = (0, _dayjs.default)(endDate).format('YYYY-MM-DD');
    const startString = (0, _dayjs.default)(startDate).format('YYYY-MM-DD');
    setEndDate(endString);
    setStartDate(startString);
    onChange(startString, endString);
  };
  const containerProps = {
    margin
  };
  const dateContainerProps = {
    disabled,
    height,
    isOpen
  };
  const rangeContainerProps = {
    center: position === 'center',
    left: position === 'left',
    right: position === 'right'
  };
  const ranges = [{
    endDate: (0, _dayjs.default)(endDate, 'YYYY-MM-DD').toDate(),
    key: 'selection',
    startDate: (0, _dayjs.default)(startDate, 'YYYY-MM-DD').toDate()
  }];
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styled.Container, _objectSpread(_objectSpread({}, containerProps), {}, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styled.DateContainer, _objectSpread(_objectSpread({}, dateContainerProps), {}, {
      onClick: toggleOpen,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styled.CurrentDate, {
        children: [(0, _dayjs.default)(startDate).format('DD/MM/YYYY'), " - ", (0, _dayjs.default)(endDate).format('DD/MM/YYYY')]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MaterialIcon.default, {
        icon: "date_range",
        size: 18
      })]
    })), isOpen && !disabled && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.RangeContainer, _objectSpread(_objectSpread({}, rangeContainerProps), {}, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactDateRange.DateRange, {
        color: primaryColor,
        dateDisplayFormat: "d/M/yyyy",
        direction: "vertical",
        disabled: disabled,
        editableDateInputs: true,
        locale: LOCALES[t("LOCALE")],
        maxDate: !allowFutureDays ? (0, _dayjs.default)().toDate() : undefined,
        minDate: (0, _dayjs.default)().subtract(3, 'year').toDate(),
        monthDisplayFormat: "MMMM yyyy",
        navigatorRenderer: () => null,
        retainEndDateOnFirstSelection: true,
        rangeColors: [primaryColor],
        ranges: ranges,
        ref: rangeRef,
        scroll: {
          calendarHeight,
          enabled: true
        },
        onChange: handleChange
      })
    }))]
  }));
};
DateRangePicker.propTypes = {
  allowFutureDays: _propTypes.default.bool,
  calendarHeight: _propTypes.default.number,
  disabled: _propTypes.default.bool,
  endValue: _propTypes.default.string,
  height: _propTypes.default.string,
  margin: _propTypes.default.string,
  onChange: _propTypes.default.func,
  position: _propTypes.default.string,
  startValue: _propTypes.default.string
};
var _default = exports.default = DateRangePicker;